import Vue from "vue"
import formatMoney from 'accounting-js/lib/formatMoney.js'

export const formatNumber = value => {
  return formatMoney(value, { symbol: ``, precision: 0, thousand: `.` })
}

Vue.filter('capitalize', function (value) {
  return value.toUpperCase()
})

Vue.filter('formatMoney', function (value) {
  return 'Rp ' + formatNumber(value)
})

Vue.filter('formatNumber', function (value) {
  return formatNumber(value)
})

Vue.filter('capitalizing', function (value) {
  if (value === 'spbu' || value === 'Spbu') {
    return value.toUpperCase()

  }
  return value.replace(/\b\w/g, function (l) { return l.toUpperCase() })
})

Vue.filter('capitalizefirst', function (value) {
  if (value === 'spbu' || value === 'Spbu') {
    return value.toUpperCase()

  } else {
    value = value.toLowerCase()
  }
  return value.replace(/^[a-z]/g, function (l) { return l.toUpperCase() })
})
